import { Text } from '@ui/lib/park/ui/text';
import { useTranslation } from 'next-i18next';
import { useContext, useMemo } from 'react';
import { Flex, HStack } from 'styled-system/jsx';
import BigNumber from 'bignumber.js';

import { ExchangeContext } from '../Context';
import { formatNumber } from '@ui/lib/bignumber';

export const RedeemFees = () => {
  const { t } = useTranslation();
  const { outputToken, outputAmount, inputAmount } = useContext(ExchangeContext);

  const fees = useMemo(() => {
    if (!inputAmount || !outputAmount) return '0';

    const inputBN = new BigNumber(inputAmount.replace(/,/g, ''));
    const outputBN = new BigNumber(outputAmount.replace(/,/g, ''));

    const fee = inputBN.minus(outputBN);

    if (fee.lt(0)) return '0';

    return formatNumber(fee, {
      displayDecimals: 6,
      isTrimTrailingZero: true,
      autoKmb: false,
    });
  }, [inputAmount, outputAmount]);

  return (
    <Flex width="full" justifyContent="space-between" alignItems="center" py={1}>
      <Text color="greyWhite.white" fontWeight="light" fontSize="14px">
        {t("common.Fees:")}
      </Text>
      <HStack gap={1}>
        <Text fontSize="14px" fontWeight="normal" color="white">
          {fees} MON
        </Text>
      </HStack>
    </Flex>
  );
};
